import React, { Fragment, useContext, useEffect, useState } from "react";
/// React router dom
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import jharkhandlogo1 from "../../../images/jharkhandlogo1.png";
import jharkhandlogo2 from "../../../images/jharkhandlogo2.png";
import jharkhandlogo3 from "../../../images/jharkhand logo3.png";
import "./style.css";
import ICLOGO from "../../../images/AquaticsLogoCollapsed.png";



export function NavMenuToggle(callback) {
  setTimeout(() => {
    const mainwrapper = document.querySelector("#main-wrapper");
    if (!mainwrapper) return;

    const isNowCollapsed = mainwrapper.classList.toggle("menu-toggle");
    callback?.(isNowCollapsed);
  }, 300);
}
const NavHader = () => {
  const loginDetails = localStorage.getItem("login_Details");
  const loginFullDetails = JSON.parse(loginDetails);
  console.log("loginDetails", loginFullDetails?.user?.name);
  const [toggle, setToggle] = useState(false);
  console.log("toggle===>", toggle);
  const { navigationHader, openMenuToggle, background } =
    useContext(ThemeContext);

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const updateState = () => {
      const mainwrapper = document.querySelector("#main-wrapper");
      const isCollapsed = mainwrapper?.classList.contains("menu-toggle");
      setIsSidebarCollapsed(isCollapsed || screenWidth < 1024);
      setScreenWidth(window.innerWidth);
    };

    updateState();
    window.addEventListener("resize", updateState);
    return () => window.removeEventListener("resize", updateState);
  }, [screenWidth]);

  const showCollapsedLogo = screenWidth < 1024 || isSidebarCollapsed;

  return (
    <div className="nav-header" style={{ zIndex: 11}}>
      <Link to="/dashboard" className="target-div">
        {showCollapsedLogo ? (
          <img
            style={{
              objectFit: "contain",
              maxHeight: "45px",
              maxWidth: "45px",
              width: "auto",
              height: "auto",
            }}
            src={ICLOGO}
            alt="International Lawn Tennis Club of India"
          />
        ) : (
          <div className="d-flex align-items-center justify-content-center gap-2 px-2" style={{ height: "100%", width: "100%" }}>
            <img
              style={{
                objectFit: "contain",
                maxHeight: "45px",
                maxWidth: "48px",
                width: "auto",
                height: "auto",
                flexShrink: 0,
              }}
              src={ICLOGO}
              alt="International Lawn Tennis Club of India"
            />
            <span
              style={{
                fontSize: "11px",
                fontWeight: 600,
                color: background.value === "dark" || navigationHader !== "color_1" ? "#ffffff" : "#1e293b",
                lineHeight: 1.2,
                textAlign: "left",
                display: "inline-block",
                maxWidth: "135px",
              }}
            >
              International Lawn Tennis Club of India
            </span>
          </div>
        )}
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          setToggle((prev) => !prev);
          NavMenuToggle(setIsSidebarCollapsed);
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
